import { render, staticRenderFns } from "./MyComment.vue?vue&type=template&id=55598f74&scoped=true&"
import script from "./MyComment.vue?vue&type=script&lang=js&"
export * from "./MyComment.vue?vue&type=script&lang=js&"
import style0 from "./MyComment.vue?vue&type=style&index=0&id=55598f74&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55598f74",
  null
  
)

export default component.exports